import { Div } from "@tblabs/truffle";


export class InfoBox extends Div
{
    constructor(text: string)
    {
        super();
        this.Text(text);
        this.Style("border-left: 3px solid #1e87f0; padding: 16px;");
    }
}
